import { JSONDecryptor,EncryptedData } from "../utils/encryptorUtil";
interface Config {
    baseURL: string;
    asstURL: string;
    version: string;
    baseURLSecurity: string;
    clientAuthKey: string;
    mapTokens: any;
    idealTimeOutPeriodInMs:number;
    googleMapToken:any;
    googleMapApiUrl:any;
    clientSecret: string;
    clientId: string;
    boundaryUrl: any;
    locateUrl: any;
    arcGISResourcesUrl: any;
    overlayPassword: any;
    showOverlay: any;
    internalVersion: any;
    minimumHeight:any;
    minimumWeight:any;
    obstetricHistory:any;
    bloodGroup:any;
    vdrlTest:any;
    hivTest:any;
    hbsagTest:any;
    thyroidTest:any;
    tbTest:any;
    malariaTest:any;
    ppTest:any;
    ogttTest:any;
    hb:any;
    foetalPresentation:any;
    foetalHeartRate:any;
    otherSymptoms:any;
    bpSystolic:any;
    bpDiastolic:any;
    bpSystolicMax:any;
    bpSystolicMin:any;
    bpDiastolicMin:any;
    bpDiastolicMax:any;
    shortStatureMin:any;
    shortStatureMax:any;
    root:any;
    isPayloadEncryptionRequired:any;
    showBenefTickerMessage:any;
    TickerMessage:any;
    disclaimerStateCodes:any;
    enableArcGISMap:any;
    apkName:any;
    sendSMSTemp:any;
    isDownloadMCPButtonVisible:any;
    dashboardMessage:string;
    userTypesToHideDashboard:any;
    tempTracing:any;
    showFaceAuth:any;
    disableCitizenLogin:any;
    serviceDateLimit:any;
    refreshSkewMs:any;
    PWandChildCountLimit:any;
    otpCooldownTime: any;
}


const currentEnv =  'config';
const root_path=process.env.ROOT_PATH||'/';
async function fetchConfig(): Promise<Config> {
    try {
        const response = await fetch(`${root_path}config/${currentEnv}.json`);
        if (!response.ok) {
            throw new Error(`Failed to load config file for ${currentEnv} environment`);
        }
        const encryptedData: EncryptedData = await response.json();

                const decryptor = new JSONDecryptor(process.env.SECRET_KEY||'');
                const data = await decryptor.decrypt<Config>(encryptedData);
        const configData: Config = data.enableArcGISMap ? data : {...data, enableArcGISMap: 'ON'};
        return configData;
    } catch(error:any){
        throw new Error("error while loading the config");
    }
}

export default await fetchConfig();
